import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Query, UserIdentityProvider, Visitor } from 'graphql/generated/graphqlTypes';
import { generateMockMobileDevice } from 'mocks/graphqlMocks/mobileDevice';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';

dayjs.extend(utc);

export function mockedGetCurrentVisitorData(getCurrentVisitor: Visitor): Pick<Query, 'getCurrentVisitor'> {
  return {
    getCurrentVisitor
  };
}

export const mockedGetCurrentVisitorUnitTestsDataForQuery = mockedGetCurrentVisitorData(
  generateMockVisitor({
    name: 'Marieke de Vries',
    email: 'automated-tests-ui-admin@iprotectcloudtest.onmicrosoft.com',
    isAdmin: true,
    id: 'mockedAutomatedTestsUIAdminVisitorId',
    identityProvider: UserIdentityProvider.Entra,
    mobileDevices: [
      generateMockMobileDevice({
        id: 'mockedMobileDevice',
        isRegistered: true,
        registrationDate: dayjs().utc().format()
      })
    ]
  })
);

export const mockedGetCurrentVisitorAdminDataForQuery = mockedGetCurrentVisitorData(
  generateMockVisitor({
    name: 'Marieke de Vries',
    email: 'automated-tests-ui-admin@iprotectcloudtest.onmicrosoft.com',
    isAdmin: true,
    id: 'mockedAutomatedTestsUIAdminVisitorId',
    identityProvider: UserIdentityProvider.Entra,
    mobileDevices: [
      generateMockMobileDevice({
        id: 'mockedMobileDevice',
        isRegistered: true,
        registrationDate: dayjs().utc().format(),
        role: 'ACCESS'
      })
    ]
  })
);

export const mockedGetCurrentVisitorNonAdminDataForQuery = mockedGetCurrentVisitorData(
  generateMockVisitor({
    name: 'Marieke de Vries',
    email: 'automated-tests-ui@iprotectcloudtest.onmicrosoft.com',
    isAdmin: false,
    id: 'mockedAutomatedTestsUIVisitorId',
    identityProvider: UserIdentityProvider.Entra,
    mobileDevices: [
      generateMockMobileDevice({
        id: 'mockedMobileDevice',
        isRegistered: true,
        registrationDate: dayjs().utc().format(),
        role: 'ACCESS'
      })
    ]
  })
);
